<body>
            <div class="container-fluid" [ngClass]="{'dark-bg' : isDark }">
              <div class="row">
                <div class="col-12">                
                  <div class="invoice p-3 mb-3"> 

                    <div class="row justify-content-center">
                        <h6>Customer Outstanding Report</h6> 
                    </div>
      
                    <!-- Table row -->
                    <div class="row">
                    <div class="col-12">
                    <div class="card" [ngClass]="{'dark-bg' : isDark ,'dark-border-color' : isDark }">                  
                     <div class="card-body">

                       <div class="row pb-2">
                        <div class="col-5">
                          <div class="input-group">
                              <span class="input-group-prepend">
                                  <div class="input-group-text bg-transparent border-right-0"><i class="fa fa-search" [ngClass]="{'dark-bg' : isDark }"></i></div>
                              </span>
                              <input [(ngModel)]="searchKey"  [formControl]="myControl"  [matAutocomplete]="autoCustomer"  [ngClass]="{'dark-bg' : isDark }" class="form-control py-2 border-left-0  border" type="text" placeholder="Search by customer name">                   
                              <mat-autocomplete autoActiveFirstOption  #autoCustomer="matAutocomplete">
                                <mat-option *ngFor="let option of filteredCustomerList | async" [value]="option.CusName">
                                  {{option.CusName}}
                                </mat-option>
                              </mat-autocomplete>           
                          </div>     
                        </div>
                        <div class="col-4 text-center">
                          <mat-radio-group (change)="checkedChangeRdoButtons($event)">  
                            <mat-radio-button class="mt-2" checked value="All" >All</mat-radio-button>
                            <mat-radio-button class="mt-2" value="Paid" >Paid</mat-radio-button>
                            <mat-radio-button class="mt-2" value="Unpaid">Unpaid</mat-radio-button>
                          </mat-radio-group>
                        </div>
                        <div class="col-3 input-group">
                          <button (click)="viewBtnClicked()" mat-raised-button>View</button>
                          <button (click)="clearBtnClicked()" mat-raised-button class="ml-2">Clear</button>                         
                        </div>
                       </div>

                      <div class="col-12 table-responsive scrollable" id="cusBalReport"  #cusBalReport>
                        <table class="table" [ngClass]="{'dark-bg' : isDark }">
                          <thead>
                          <tr >                          
                            <th>InvoiceNo</th>
                            <th>InvoiceDate</th>
                            <th>Customer</th>
                            <th>PmtType</th>
                            <th>DueDate</th>
                            <th>Due</th>
                            <th>PoNo</th>
                            <th>CreatedBy</th>
                            <th>Status</th>
                            <th class="text-right">InvoiceTotal</th>                         
                            <th class="text-right">AmountPaid</th>
                            <th class="text-right">Balance</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr *ngFor="let item of filteredFinalList">    
                            <td>{{item.InvoiceNo}}</td>
                            <td>{{item.InvoiceDate | date :'y-MM-dd'}}</td>
                            <td>{{item.CusName}}</td>
                            <td>{{item.PaymentTerm}}</td>
                            <td>{{item.DueDate | date :'y-MM-dd'}}</td>           
                            <td><span class="badge" [ngClass]="{'badge-danger' :   convertDateToMySql(inputToday)  >   convertDateToMySql(item.DueDate),'badge-success' :   convertDateToMySql(inputToday)  <=   convertDateToMySql(item.DueDate) }" >{{ getDayDiffrence(item.InvoiceDate,item.PaymentType,item.Status)}}</span></td>  
                             <td>{{item.PoNo}}</td>
                            <td>{{item.CreatedBy}}</td>  
                            <td><span class="badge" [ngClass]="{'badge-warning' : item.Status==='Unpaid','badge-info' : item.Status==='Partially paid', 'badge-success' : item.Status==='Paid' }" >{{item.Status}}</span></td> 
                            <td class="text-right">{{item.GrandTotal |  number:'1.2-2'}}</td>
                            <td class="text-right">{{item.AmountPaid |  number:'1.2-2'}}</td>                                                    
                            <td class="text-right">{{item.BalToPay |  number:'1.2-2'}}</td>
                          </tr> 
                          <tr class="table-active">
                              <td colspan="11" class="text-right text-bold">Total Balance :</td>
                              <td class="text-right text-bold">{{getTotalBalance() | number:'1.2-2'}}</td>
                            </tr>                                              
                          </tbody>
                        </table>
                      </div>
                      <!-- /.col -->
                     </div>
                    </div>
                    </div>
                    </div>
                    <!-- /.row -->
      
      
                    <!-- this row will not appear when printing -->
                    <div class="row no-print">
                      <div class="col-12">   
                        <!-- <button type="button" printSectionId="cusBalReport" [useExistingCss]="true" ngxPrint  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>   -->
                         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('print')"  class="btn btn-default float-right"><i class="fas fa-print"></i> Print</button>      
                        <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="exportexcel()"  class="btn btn-default float-right"><i class="fa fa-file-excel-o" style="color:green"></i> Excel</button>      
                         <button [ngClass]="{'dark-bg' : isDark }" type="button" (click)="savePDF('open')"  class="btn btn-default float-right"><i class="fa fa-file-pdf-o" style="color:red"></i> PDF</button>                                                                                                                                                              
                      </div>
                    </div>


                  </div><!-- /.invoice -->                 
                </div><!-- /.col -->
              </div><!-- /.row -->
            </div><!-- /.container-fluid -->         
 </body>


